import React, { useContext, useEffect, useState, useReducer } from "react";
import AppBar from "@material-ui/core/AppBar";
import Toolbar from "@material-ui/core/Toolbar";
import IconButton from "@material-ui/core/IconButton";
import MenuIcon from "@material-ui/icons/Menu";
import MoreIcon from "@material-ui/icons/MoreVert";
import MenuItem from "@material-ui/core/MenuItem";
import Menu from "@material-ui/core/Menu";
import LanguageSwitcher from "../../LanguageSwitcher";
import Box from "@material-ui/core/Box";
import SearchBar from "../../SearchBar";
import useStyles from "./AppHeader.style";
import HeaderMessages from "../../HeaderMessages";
import Notifications from "../../Notifications";
import AppLogo from "../../../../shared/components/AppLogo";
import clsx from "clsx";
import { toggleNavCollapsed, useLayoutActionsContext, toggleNavCollapsedAuto } from "../LayoutContextProvider";
import { ExitToApp } from "@material-ui/icons";
import { Button, Tooltip } from "@material-ui/core";
import IntlMessages from "@crema/utility/IntlMessages";
import { setAuthToken } from "@crema/services/ApiConfig";
import AppContextPropsType from "types/AppContextPropsType";
import { AppContext } from "@crema";
import { setContext } from "@apollo/client/link/context";
import { useHistory, useLocation } from "react-router-dom";
import {
  ApolloClient,
  gql,
  InMemoryCache,
  createHttpLink,
} from "@apollo/client";
import { getUserEmail } from "@crema/utility/AppHooks";
import AppLogOut from "modules/auth/AppLogOut";
import HeaderTask from "../HeaderTask";
import HeaderUrgentTask from "../HeaderUrgentTask";
interface AppHeaderProps { }

const AppHeader: React.FC<AppHeaderProps> = () => {
  const classes = useStyles();
  const history = useHistory();
  const dispatch = useLayoutActionsContext()!;
  const [
    mobileMoreAnchorEl,
    setMobileMoreAnchorEl,
  ] = useState<null | HTMLElement>(null);
  const { themeMode, updateAuthUser } = useContext<AppContextPropsType>(AppContext);
  const location = useLocation();

  useEffect(() => {
    if (location.pathname == '/appointments/video-consultation') {
      dispatch(toggleNavCollapsedAuto())
    } else {
      //dispatch(toggleNavCollapsed())
    }

  }, [location]);

  const fetchDataApi = (email: string, refreshToken: String) => {
    // console.log("in auth in fetchDataApi;")
    const apolloHttpLink1 = createHttpLink({
      uri: process.env.REACT_APP_API_URL,
    });
    const client1 = new ApolloClient({
      link: apolloHttpLink1.concat(apolloHttpLink1),
      cache: new InMemoryCache({
        addTypename: false,
      }),
    });



    return new Promise((resolve, reject) => {
      // console.log("in auth before Promise;");
      client1
        .mutate({
          mutation: gql`
  mutation{
    refreshToken(
  resource:{
    resourceType:User,
    email:"${email}"
      refreshToken:"${refreshToken}"
  
  }){
    status
    message
    tokenresult
  }
  }
  
  
  `,
        })
        .then((result) => {
          // console.log("in auth before Promise;");
          if (result != null && result.data != null && result.data.refreshToken != null && result.data.refreshToken.status == 1) {
            let tokenData = JSON.parse(result.data.refreshToken.tokenresult);
            let refreshToken = tokenData['refreshToken']['token'];
            let accesToken = tokenData['accessToken']['jwtToken'];

            let tokenExpiryDate = tokenData['accessToken']['payload']['exp'];
            localStorage.setItem("refreshToken", refreshToken);
            localStorage.setItem("accesToken", accesToken);
            localStorage.setItem("tokenExpiryDate", tokenExpiryDate);
            // console.log("refershtoken::", refreshToken)
            resolve(1);

          } else {
            // console.log("in auth before else 0 ;");

            updateAuthUser(null);
            setAuthToken(null);
            history.push("/login");
            resolve(0);
            //logout user
          }
          //logout API goes Here




        });

      //add here

    });
  };
  const apolloAuthLink = setContext(async (request, { headers }) => {

    var now = new Date;
    var utc_timestamp = Date.UTC(now.getFullYear(), now.getMonth(), now.getDate(),
      now.getHours(), now.getMinutes(), now.getSeconds(), now.getMilliseconds());

    //    const tokenEDate = new Date(1658840492);

    let currentTime = Math.floor(utc_timestamp / 1000)


    // get the authentication token from local storage if it exists
    let refreshToken = '';
    let refreshTokenL = localStorage.getItem("refreshToken");
    if (refreshTokenL) {
      refreshToken = refreshTokenL;
    }
    let accesToken = localStorage.getItem("accesToken");
    let tokenExpiryDate = localStorage.getItem("tokenExpiryDate");
    if (tokenExpiryDate != null && accesToken != null) {
      let tokenExpiryDate1 = parseInt(tokenExpiryDate);


      if (tokenExpiryDate1 > currentTime) {
        // console.log("in auth not expired");
        // token not expird
      } else {

        // console.log("in auth before await change;")
        const loggedInEmail = getUserEmail();

        let getdata = await fetchDataApi(loggedInEmail, refreshToken);
        accesToken = localStorage.getItem("accesToken");
        // console.log("in auth after wawait;")
        //call refershToken
      }
    }


    return {
      headers: {
        ...headers,
        authorization: accesToken,
      },
    };
  });
  const apolloHttpLink = createHttpLink({
    uri: process.env.REACT_APP_API_URL,
  });

  const client = new ApolloClient({
    link: apolloAuthLink.concat(apolloHttpLink),
    cache: new InMemoryCache({
      addTypename: false,
    }),
  });
  const onUserSignout = () => {

    let activityid = localStorage.getItem('activityid');

    // console.log("activityid::", activityid)
    if (activityid != null) {


      client
        .mutate({
          mutation: gql`
     mutation{
      PomsPractitionerActivityUpdate(
    resource:{
      resourceType:PomsPractitionerActivity,
    id:"${activityid}"
   
    
  }){
    id,
   
  }
  }
      
      
      `,
        })
        .then((result) => {
          //logout API goes Here
          // console.log("result::", result);
          updateAuthUser(null);
          setAuthToken(null);
          history.push("/signin");
        });

    } else {
      //logout API goes Here
      updateAuthUser(null);
      setAuthToken(null);
      history.push("/signin");
    }

  };
  const isMobileMenuOpen = Boolean(mobileMoreAnchorEl);

  function handleMobileMenuClose() {
    setMobileMoreAnchorEl(null);
  }

  function handleMobileMenuOpen(event: React.MouseEvent<HTMLElement>) {
    setMobileMoreAnchorEl(event.currentTarget);
  }

  const mobileMenuId = 'primary-search-account-menu-mobile';
  const renderMobileMenu = (
    <Menu
      anchorEl={mobileMoreAnchorEl}
      anchorOrigin={{ vertical: 'top', horizontal: 'right' }}
      id={mobileMenuId}
      keepMounted
      transformOrigin={{ vertical: 'top', horizontal: 'right' }}
      open={isMobileMenuOpen}
      onClose={handleMobileMenuClose}>
      <MenuItem className={classes.menuItemRoot}>
        <HeaderUrgentTask />
      </MenuItem>
      <MenuItem className={classes.menuItemRoot}>
        <HeaderTask />
      </MenuItem>
      <MenuItem className={classes.menuItemRoot}>
        <HeaderMessages />
      </MenuItem>
      <MenuItem className={classes.menuItemRoot}>
        <Notifications />
      </MenuItem>
      <MenuItem className={classes.menuItemRoot}>
        <IconButton
          aria-label='show more'
          aria-controls={mobileMenuId}
          aria-haspopup='true'
          color='inherit' onClick={onUserSignout}>
          <ExitToApp style={{ width: '50px' }} />
          <span style={{ fontSize: '16px', fontFamily: 'Roboto-Regular' }}>Logout</span>
        </IconButton>
      </MenuItem>
      {/* <LanguageSwitcher /> */}
    </Menu>
  );




  return (
    <>
      <AppLogOut>
        <AppBar color='inherit' className={clsx(classes.appBar, 'app-bar')}>
          <Toolbar className={classes.appToolbar}>
            {/* {location.pathname != '/appointments/video-consultation' && */}
            <IconButton
              edge='start'
              className={classes.menuButton}
              color='inherit'
              aria-label='open drawer'
              onClick={() => dispatch(toggleNavCollapsed())}>
              <MenuIcon className={classes.menuIcon} />
            </IconButton>
            {/* } */}

            <AppLogo />
            <Box className={classes.grow} />
            {/* <SearchBar borderLight placeholder='Search…' /> */}
            <Box className={classes.sectionDesktop}>
              <HeaderUrgentTask />
              {/* <LanguageSwitcher /> */}
              <HeaderTask />
              <HeaderMessages />
              <Notifications />
              <Tooltip title={<IntlMessages id='header.tooltip.logout' />}>
                <Button className="logoutBtn" variant="outlined" onClick={onUserSignout} aria-controls={mobileMenuId} startIcon={<ExitToApp />}>
                  Logout
                </Button>
              </Tooltip>
            </Box>
            <Box className={classes.sectionMobile}>
              <IconButton
                aria-label='show more'
                aria-controls={mobileMenuId}
                aria-haspopup='true'
                onClick={handleMobileMenuOpen}
                color='inherit'>
                <MoreIcon />
              </IconButton>
            </Box>
          </Toolbar>
        </AppBar>
        {renderMobileMenu}
      </AppLogOut>
    </>
  );
};
export default AppHeader;
function updateAuthUser(arg0: null) {
  throw new Error("Function not implemented.");
}

